/**
 * Etapy lejka zapisywane z przeglądarki. Reszta progów (rezerwacje, płatności,
 * rezygnacje) liczy się z tabel domenowych i nie ma tu odpowiednika.
 */
export enum FunnelEventStage {
  OFFER_VIEWED = 'OFFER_VIEWED',
  OFFER_VIEWED_NOT_OPEN = 'OFFER_VIEWED_NOT_OPEN',
  OFFER_VIEWED_CLOSED = 'OFFER_VIEWED_CLOSED',
  OFFER_VIEWED_SOLD_OUT = 'OFFER_VIEWED_SOLD_OUT',
  WAITLIST_VIEWED = 'WAITLIST_VIEWED',
  FORM_STARTED = 'FORM_STARTED',
  SUMMARY_VIEWED = 'SUMMARY_VIEWED',
}
